import PropTypes from 'prop-types';

import { Loader, For } from 'shared';
import { FlexItem } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { dateUtils, getPictureUrl } from 'shared_DEPRECATED/utils';

import {
  SprintHistoryItem,
  SprintHistoryList,
  SprintHistorySection,
} from 'features/sprint/components/History';
import useSprintHistoryQuery from 'features/sprint/hooks/query/useSprintHistory';
import { groupBySprintWeek } from 'features/sprint/utils';

import { useSidebarContext } from 'shared/components/Sidebar/context';
import { Typography } from 'shared/components/Typography';

const SprintHistoryContent = ({ selectedSprintId }) => {
  const { sprints } = useSidebarContext();
  const { history, isFetching } = useSprintHistoryQuery({
    sprintId: selectedSprintId,
  });

  const selectedSprint = sprints?.find(
    (sprint) => sprint.sprintId === selectedSprintId
  );

  const sections = selectedSprint
    ? groupBySprintWeek(history, selectedSprint)
    : {};

  if (isFetching) {
    return <Loader />;
  }

  return (
    <>
      <Spacer size="lg zr zr" />
      <SprintHistoryList itemsCount={Object.keys(sections).length}>
        <For
          each={Object.entries(sections)}
          fallback={
            <FlexItem>
              <Typography type="meta" color="gray" fontWeight="regular">
                No changes made to the sprint.
              </Typography>
            </FlexItem>
          }
        >
          {([sectionTitle, sprintChanges], index) => (
            <SprintHistorySection
              key={sectionTitle}
              index={index}
              title={sectionTitle}
            >
              <For each={sprintChanges}>
                {(
                  {
                    recordedAt,
                    editorEmail,
                    editorName,
                    editorPicture,
                    challengeTitle,
                    before,
                    after,
                    type,
                  },
                  index
                ) => (
                  <SprintHistoryItem
                    key={index}
                    date={dateUtils.todayTimeAgoOrDate(recordedAt)}
                    userEmail={editorEmail}
                    userName={editorName}
                    userPictureUrl={getPictureUrl(editorPicture)}
                    challengeTitle={challengeTitle}
                    before={before}
                    after={after}
                    type={type}
                    sprintWeeksCount={selectedSprint.weeksCount}
                  />
                )}
              </For>
            </SprintHistorySection>
          )}
        </For>
      </SprintHistoryList>
    </>
  );
};

SprintHistoryContent.propTypes = {
  selectedSprintId: PropTypes.string.isRequired,
};

export default SprintHistoryContent;
